

import measurementTypes from './MeasurementTypes'

const measurementVisibility = {

    visibleToUser(measurementType) {
        let type = measurementType.id;
        switch(type) {
            case 'ambientO2':
            case 'ambientCO2':
            case 'longitude':
            case 'latitude':
            case 'elevation':
            case 'distance':
            case measurementTypes.StepSpeedIntensity:
            case measurementTypes.StepPowerIntensity:
            case measurementTypes.StepInclination:
                return false;
            default:
                return true;
        }
    },

};

export default measurementVisibility